import Typography from "core/components/Typography";
import Error from "core/components/Error";
import Toggle from "core/components/Toggle";
import { ErrorBoundary } from "@datadog/browser-rum-react";
import ProductSettingsCard from "./ProductSettingsCard";
import ProductTitleCard from "./ProductTitleCard";
import { HeaderWithTooltip } from "core/components/Table";
import ProductTooltip from "./ProductTooltip";
import LicenseControl from "./LicenseControl";

const ProductPage = ({ product, catalog }) => {
  const { id, meta, page, fields, fieldErrors } = product;

  return (
    <div>
      <ErrorBoundary
        onError={console.error}
        fallback={({ error, resetError }) => {
          console.log({ error, resetError });
          console.error(error);
          return (
            <Error>
              We encountered an issue while attempting to load this page. Please
              contact support for assistance.
            </Error>
          );
        }}
      >
        <ProductTitleCard data-test="product-title-card">
          <div>
            <HeaderWithTooltip
              info={
                <ProductTooltip
                  product={product}
                  catalog={catalog}
                  listStyle={{ padding: 5 }}
                />
              }
              clickable={true}
              style={{
                fontSize: 24,
                fontWeight: 700,
                color: "#000000",
              }}
              iconStyle={{
                height: 24,
                width: 24,
                position: "relative",
              }}
              tooltipPlace="bottom"
            >
              {meta.name}
            </HeaderWithTooltip>
          </div>
          <Toggle
            buttonStyle={{
              zIndex: 10000,
              border: "1px solid rgba(255, 255, 255, .4)",
            }}
            style={{
              height: 28,
            }}
            id={`${product.id}-${fields.isEnabled.dataId}`}
            value={page.isEnabled.getValue()}
            onChange={page.isEnabled.setValue}
            dataTest={id}
          />
        </ProductTitleCard>
        {page.settings.map((setting, index) => {
          return (
            <ProductSettingsCard
              key={setting.title}
              data-test={`product-setting-card-${index}`}
            >
              <Typography variant="h4" color="black" mb="xs">
                {" "}
                {setting.title}
              </Typography>
              <Typography variant="p" color="body" mb="md">
                {setting.description}
              </Typography>

              {setting.controls.map((control, index) => {
                return (
                  <LicenseControl
                    key={control.fieldKey || index}
                    index={index}
                    control={control}
                    error={fieldErrors[control.fieldKey] || ""}
                    dataTest={control.fieldKey || control.componentType}
                  />
                );
              })}
            </ProductSettingsCard>
          );
        })}
      </ErrorBoundary>
    </div>
  );
};

export default ProductPage;
